import $ from 'jquery';

export default () => {
  // Helper functions for cookies
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  };

  // Get dismissed notifications from cookie
  const dismissedNotifications = getCookie('dismissed-notifications')
    ? JSON.parse(getCookie('dismissed-notifications'))
    : [];

  $('.block-notification').each(function () {
    const block = $(this);
    const notificationId = block.data('id');

    // Only show if not dismissed
    if (!dismissedNotifications.includes(notificationId)) {
      block.show();
    }

    block.find('.close-notification').on('click', () => {
      block.slideUp();

      // Add to dismissed list and update cookie
      dismissedNotifications.push(notificationId);
      setCookie('dismissed-notifications', JSON.stringify(dismissedNotifications), 2);

      return false;
    });
  });
};
